export const REPORT_PREVIEW_ACTIONS = {
  'SET_STATE': 'REPORT_PREVIEW_SET_STATE',
  'SET_FINAL': 'REPORT_PREVIEW_SET_FINAL',
  'SET_ADDENDUM': 'REPORT_PREVIEW_SET_ADDENDUM',
  'INIT_REVIEWS': 'REPORT_PREVIEW_INIT_REVIEWS',
  'SET_SUMMARIES': 'REPORT_PREVIEW_SET_SUMMARIES'
};
